module.exports = __webpack_public_path__ + "media/newstyle/images/your-book-mini-aus-8c0d9200cc1643da7cb79bf54bcfe39f.png";